import { fmt } from "@nabble/ui";
import type { DataRequest } from "../../../../api/dataRequests";
import { isAnswered } from "../../../../model/dataRequests";

/** The answer column as plain text (for sorting and copying): the resolution, or the deadline still running. */
export function answerText(r: DataRequest): string {
  if (isAnswered(r.status)) return r.resolution ?? "";
  const due = `Answer by ${fmt.date(r.dueAt)}`;
  return r.extended && r.extensionReason ? `${due}. Extended: ${r.extensionReason}` : due;
}
